import React from "react";
import styles from "./index.module.scss";
export const DisplayLargeText = (text) => {
    return React.createElement("div", { className: styles.formatted }, text);
};
